import { EXPAND_SECTION, COLLAPSE_SECTION, TOGGLE_SECTION, PUSH_SECTION } from './AccordionConstants';

export const expandSection = id => ({
    type: EXPAND_SECTION,
    payload: id
});

export const collapseSection = id => ({
    type: COLLAPSE_SECTION,
    payload: id
});

export const toggleSection = id => ({
    type: TOGGLE_SECTION,
    payload: id
});

export const pushSection = (id, isExpanded) => ({
    type: PUSH_SECTION,
    payload: {
        id,
        isExpanded
    }
});
